import { sortBy } from 'lodash';
export default function getLocations() {
    return sortBy([
        {
            name: 'Kudal',
            image: 'kudal.webp',
            sort_order: 1
        },
        {
            name: 'Kankavli',
            image: 'kankavli.webp',
            sort_order: 2
        },
        {
            name: 'Malvan',
            image: 'malvan.webp',
            sort_order: 3
        },
        {
            name: 'Sawantwadi',
            image: 'sawantwadi.webp',
            sort_order: 4
        },
        {
            name: 'Tarkarli',
            image: 'tarkarli.webp',
            sort_order: 5
        },
        {
            name: 'Ratnagiri',
            image: 'ratnagiri.webp',
            sort_order: 6
        },
        {
            name: 'Vengurla',
            image: 'vengurla.webp',
            sort_order: 7
        },
        {
            name: 'Devbag',
            image: 'devbag.webp',
            sort_order: 8
        },
        {
            name: 'Devgad',
            image: 'devgad.webp',
            sort_order: 9
        },
        {
            name: 'Kunkeshwar',
            image: 'kunkeshwar.webp',
            sort_order: 10
        },
        {
            name: 'Vaibhavwadi',
            image: 'vaibhavwadi.webp',
            sort_order: 11
        },
        {
            name: 'Ganpatipule',
            image: 'ganpatipule.webp',
            sort_order: 12
        },
        {
            name: 'Navi Mumbai',
            image: 'navi_mumbai.webp',
            sort_order: 13
        },
        {
            name: 'Thane',
            image: 'thane.webp',
            sort_order: 14
        },
        {
            name: 'Mumbai',
            image: 'mumbai.webp',
            sort_order: 15
        },
    ], ['sort_order']);
}